import React from "react";
import BasePage from "../../base/BasePage";
import withRouter from "../../withRouter";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-coverflow";
import Slider from "../../components/marqueeslider";
import Footer from "../../components/footer";
import Navigation from "../../components/Navigation";
import Socials from "../../components/socialbottom";
import { hotels } from "./hotels";
import { promotionsShangriLa } from "./promotionsShangriLa";
import { promotionsHolidayInn } from "./promotionsHolidayInn";
import { promotionsDusitThaniManila } from "./promotionsDusitThaniManila";
import { promotionsAscottMakati } from "./promotionsAscottMakati";
import { promotionsSedaResidencesMakati } from "./promotionsSedaResidencesMakati";
import { promotionsTheMiniSuites } from "./promotionsTheMiniSuites";
import ClientPagePresenter from "./ClientPagePresenter";
import { signOutUseCase } from "../../usecases/user";
import { Navigate } from "react-router-dom";

class ClientPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new ClientPagePresenter(
      this,
      signOutUseCase(),
      signOutUseCase()
    );
    this.state = {
      isModalOpen: false,
      selectedHotel: null,
      selectedPromotion: null,
    };
  }

  logout() {
    this.presenter.onClickSignOut();
  }

  openModal = (hotel, promotions) => {
    this.setState({
      isModalOpen: true,
      selectedHotel: hotel,
      selectedPromotion: promotions,
    });
  };

  closeModal = () => {
    this.setState({
      isModalOpen: false,
      selectedHotel: null,
      selectedPromotion: null,
    });
  };

  render() {
    // if (true) {
    //   return this.navigateTo("/");
    // }
    return (
      <>
        <section
          className="first-section"
          style={{
            position: "sticky",
            top: 0,
            left: 0,
            width: "100%",
            height: "15vh",
            backgroundColor: "#F0F0EB",
            zIndex: 10,
          }}
        >
          <Navigation logout={this.logout.bind(this)} />
          <div
            className="position-fixed top-25 start-50 translate-middle-x text-center py-3"
            style={{
              top: "80px",
              zIndex: "100",
              width: "100%",
              backgroundColor: "#F0F0EB",
              height: "60px",
            }}
          >
            <h1 className="fw-bold" style={{ color: "#303030" }}>
              Our <i style={{ color: "#D18237" }}>Clients</i>
            </h1>
          </div>
          <Slider />
        </section>

        <section
          className="second-section"
          style={{
            position: "relative",
            zIndex: 1,
            marginTop: "210px",
          }}
        >
          <div className="container-fluid p-5">
            <div className="row">
              {hotels.map((hotel, index) => (
                <div key={index} className="col-md-6 mb-4">
                  <div className="p-4  d-flex flex-column">
                    {/* <img
                      src={hotel.logo}
                      alt={hotel.name}
                      className="me-3 rounded"
                      style={{
                        width: "50px",
                        height: "50px",
                        marginBottom: "15px",
                      }}
                    /> */}
                    <div>
                      <h5 className="fw-bold">{hotel.name}</h5>
                      <p className="text-muted">{hotel.description}</p>
                      <p>
                        <strong>Address:</strong> {hotel.address} <br />
                        <strong>Phone:</strong> {hotel.phone} <br />
                        <strong>Email:</strong> {hotel.email}
                      </p>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          if (hotel.name === "Shangri-la Makati") {
                            this.openModal(hotel, promotionsShangriLa);
                          } else if (
                            hotel.name === "Holiday Inn & Suites Makati"
                          ) {
                            this.openModal(hotel, promotionsHolidayInn);
                          } else if (hotel.name === "Dusit Thani Manila") {
                            this.openModal(hotel, promotionsDusitThaniManila);
                          } else if (hotel.name === "Ascott Makati") {
                            this.openModal(hotel, promotionsAscottMakati);
                          } else if (hotel.name === "Seda Residences Makati") {
                            this.openModal(
                              hotel,
                              promotionsSedaResidencesMakati
                            );
                          } else if (hotel.name === "The Mini Suites") {
                            this.openModal(hotel, promotionsTheMiniSuites);
                          }
                        }}
                        className="fw-bold text-decoration-underline"
                        style={{
                          color: "#265985",
                          background: "none",
                          border: "none",
                          padding: "0",
                          cursor: "pointer",
                        }}
                      >
                        Promotions
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {this.state.isModalOpen && (
          <div
            className="modal"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.5)",
              overflow: "hidden",
            }}
          >
            <div
              className="modal-content"
              style={{
                backgroundColor: "white",
                margin: "10% auto",
                padding: "20px",
                width: "65%",
                maxHeight: "90vh",
                borderRadius: "15px",
              }}
            >
              <div
                className="d-flex align-items-center"
                style={{
                  position: "sticky",
                  top: "0",
                  background: "white",
                  zIndex: 10,
                  paddingBottom: "10px",
                }}
              >
                <button
                  onClick={this.closeModal}
                  style={{
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <i className="bi bi-arrow-left fw-bold"></i>
                </button>
                <div className="ms-3">
                  <h6 className="mb-0">
                    <b>Promotions</b>
                  </h6>
                  <h7 className="text-muted">
                    {this.state.selectedHotel?.name}
                  </h7>
                </div>
              </div>

              <div
                className="container p-4"
                style={{ maxHeight: "600px", overflowY: "auto" }}
              >
                <div className="row g-2">
                  {this.state.selectedPromotion?.map((promo, index) => (
                    <div key={index} className="col-md-6">
                      <div className="card shadow-sm border-1">
                        <img
                          src={promo.image}
                          className="card-img-top"
                          style={{ height: "180px", objectFit: "cover" }}
                          alt={promo.title}
                        />
                        <div className="card-body">
                          <h6 className="card-title fw-bold">{promo.title}</h6>
                          <p className="card-text">{promo.description}</p>
                          {promo.date && (
                            <p
                              className="card-text"
                              style={{ marginTop: "-10px" }}
                            >
                              <b>Date:</b> {promo.date}
                            </p>
                          )}
                          <div className="d-flex justify-content-end align-items-center">
                            <a
                              href={promo.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <button
                                style={{
                                  color: "#1C81D7",
                                  fontSize: "15px",
                                  paddingRight: "12px",
                                  border: "none",
                                  background: "transparent",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                Know More{" "}
                                <i
                                  className="bi bi-arrow-up-right"
                                  style={{
                                    backgroundColor: "#1C81D7",
                                    padding: "5px",
                                    borderRadius: "50%",
                                    color: "white",
                                    fontSize: "10px",
                                    marginLeft: "7px",
                                    display: "inline-flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                ></i>
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
        <section>
          <Footer />
        </section>
        <section>
          <Socials />
        </section>
      </>
    );
  }
}

export default withRouter(ClientPage);
